import React from 'react';
import './WalletCard.scss'; // optional SCSS

import {NODE_API, _IsLink} from 'constants/index';
import icongrid from '../../../../../../assets/images/icongrid.png';
import fallbackWalletLogo from '../../../../../../assets/images/logo_white.png';

function getWalletLogo(logo?: string) {
  const value = logo?.trim();
  if (!value) return fallbackWalletLogo;
  if (value.startsWith('data:image/')) return value;
  if (value.startsWith('//')) return `https:${value}`;
  if (_IsLink(value)) return value;

  const path = value.startsWith('/') ? value : `/${value}`;
  return `${NODE_API}${path}`;
}

function WalletCard({
  wallet,
  onClick,
}: {
  wallet: {
    logo?: string;
    name?: string;
    accountNumber?: string;
    balance?: number;
    backgroundColor?: string; // e.g. "#97180C" for ABSA
  };
  onClick?: () => void;
}) {
  const [logoSrc, setLogoSrc] = React.useState(() =>
    getWalletLogo(wallet.logo),
  );

  React.useEffect(() => {
    setLogoSrc(getWalletLogo(wallet.logo));
  }, [wallet.logo]);

  return (
    <div
      className="wallet-card"
      style={{backgroundColor: wallet.backgroundColor || '#013333'}}
      onClick={onClick}
    >
      {/* Pattern image absolutely positioned behind */}
      <img className="pattern-image" src={icongrid} alt="pattern" />

      {/* Logo from "wallet.logo" */}
      <img
        className="wallet-logo"
        src={logoSrc}
        alt="wallet logo"
        onError={() => {
          if (logoSrc !== fallbackWalletLogo) {
            setLogoSrc(fallbackWalletLogo);
          }
        }}
      />

      {/* Wallet name */}
      <div className="wallet-name">{wallet.name || 'Wallet'}</div>

      {/* Optional account number */}
      {wallet.accountNumber && (
        <div className="wallet-account-number">{wallet.accountNumber}</div>
      )}

      {/* Balance */}
      <div className="wallet-balance">
        R{wallet.balance?.toLocaleString() ?? '0.00'}
      </div>
    </div>
  );
}

export default WalletCard;
